import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";

import { useAuth, useModal } from "../../hooks";
import { useApplicationsData } from "./hooks";

import { Button, Loader, Pagination } from "../../components";
import { ApplicationCard } from "./components/ApplicationCard";
import { AddApplication } from "./components/AddApplication";
import { EmptyPage } from "../../components/empty-page/EmptyPage";
import { Modal } from "../../components/modal/Modal";

// import { ErrorMessage } from "../../components/error/ErrorMessage"; // Example component

import "./ApplicationsPage.scss";

function ApplicationsPage() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);

    const { isOpen: isAddModalOpen, openModal: openAddModal, closeModal: closeAddModal } = useModal();

    const {
        applications,
        totalPages,
        hasApplications,
        isLoading,
        isValidating,
        error
    } = useApplicationsData(user?.accountId, currentPage);

    const handleAddApplicationSubmit = useCallback(async (application) => {
        closeAddModal();
        navigate(`/app/applications/${application.id}`);
    }, [closeAddModal, navigate /*, mutate */]);

    const handlePageChange = useCallback((page) => {
        setCurrentPage(page);
        window.scrollTo(0, 0);
    }, []);

    if (isLoading) {
        return (
            <div className="applications-page applications-page--loading">
                <Loader loading={isLoading} />
            </div>
        );
    }

    if (error) {
        return (
            <div className="applications-page applications-page--error">
                {/*<ErrorMessage message={`Failed to load applications: ${error.message}`} onRetry={() => window.location.reload()} />*/}
                <p>`Failed to load applications: ${error.message}`</p>
            </div>
        );
    }
    const showEmptyState = !hasApplications && currentPage === 1 && !isValidating;

    return (
        <div className="applications-page">
            {showEmptyState ? (
                <EmptyPage onSubmit={openAddModal} />
            ) : (
                <>
                    <div className="add-application">
                        <Button
                            label="Add Application"
                            icon={faSquarePlus}
                            variant="primary"
                            size="xl"
                            onClick={openAddModal}
                        />
                    </div>

                    {hasApplications ? (
                        <div className="applications-container">
                            <div className="applications">
                                {applications.map((application) => (
                                    <ApplicationCard key={application.id} application={application} />
                                ))}
                            </div>
                        </div>
                    ) : (
                        !isValidating && currentPage > 1 && <p>No applications found on this page.</p>
                    )}

                    {totalPages > 1 && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    )}
                </>
            )}

            <Modal show={isAddModalOpen} onClose={closeAddModal} className="wide">
                <AddApplication onSubmit={handleAddApplicationSubmit} onClose={closeAddModal} />
            </Modal>
        </div>
    );
}

export { ApplicationsPage };
